
export const StartupApplicationStatus = [
    {
        text: 'Submit',
        value: 'SUBMIT',
    },
    {
        text: 'Approved',
        value: 'APPROVE',
    },
    {
        text: 'Incomplete',
        value: 'INCOMPLETE',
    },
    {
        text: 'Recognition Cancelled',
        value: 'CANCELLED',
    },
    {
        text: 'Expired',
        value: 'EXPIRED',
    },
    {
        text: 'On Hold',
        value: 'ON_HOLD',
    }
];



export const SearchByStartupApplicationOptions = (sectorOptions,natureOption) => {

    return [
        {
            text: "Certificate Number",
            value: "randomReg",
            searchFields: [{
                field: 'text',
                name: 'randomReg'
            }],
        },
        {
            text: "Registration No",
            value: "incorporationNumber",
            searchFields: [{
                field: 'text',
                name: 'incorporationNumber'
            }],
        }, 
        {
            text: "Reference No",
            value: "referenceNumber",
            searchFields: [{
                field: 'text',
                name: 'referenceNumber'
            }],
        },
        {
            text: "Registration Date",
            value: "incorporationDate",
            searchFields: [{
                field: 'date',
                name: 'incorporationStartDate',
                label: 'Start Date'
            }, {
                field: 'date',
                name: 'incorporationEndDate',
                label: 'End Date'
            }],
        },
        {
            text: "Status",
            value: "status",
            searchFields: [{
                field: 'select',
                name: 'status',
                options: StartupApplicationStatus,
            }]
        }
    ]
}


